module.exports = __webpack_public_path__ + "img/pt-icon.6c019918.png";